import { defineMessages } from 'react-intl';

import { Ball } from '@sorare/core/src/atoms/icons/Ball';
import { RivalsFist } from '@sorare/core/src/atoms/icons/RivalsFist';
import { UserCheck } from '@sorare/core/src/atoms/icons/UserCheck';
import { DownloadApp } from '@sorare/core/src/components/DownloadApp';

type Props = { open: boolean; onClose: (doNotShowAgain: boolean) => void };

const messages = defineMessages({
  startingLineupAnnouncements: {
    id: 'SetReminderDownloadApp.listItem.startingLineups',
    defaultMessage: 'Starting Lineups Announcements',
  },
  friendlyChallenges: {
    id: 'SetReminderDownloadApp.listItem.friendlyChallenges',
    defaultMessage: 'Friendly Challenge Requests',
  },
  livePerformanceUpdates: {
    id: 'SetReminderDownloadApp.listItem.liveUpdates',
    defaultMessage: 'Live Performance Updates',
  },
});

const benefits = [
  {
    id: 'startinglineup-announcements',
    Component: UserCheck,
    label: messages.startingLineupAnnouncements,
  },
  {
    id: 'friendly-challenges',
    Component: RivalsFist,
    label: messages.friendlyChallenges,
  },
  {
    id: 'live-performance-updates',
    Component: Ball,
    label: messages.livePerformanceUpdates,
  },
];

export const SetReminderDownloadApp = ({ open, onClose }: Props) => {
  return <DownloadApp open={open} onClose={onClose} benefits={benefits} />;
};
